import { StandardEvents } from '@shopify/events';
import { DrawerOpenEvent } from '@theme/theme-drawer';

const dialog = document.getElementById('mpc-shipping-upsell');
if (dialog && dialog.dataset.currency === 'USD') {
  const root = dialog.dataset.root.endsWith('/') ? dialog.dataset.root : dialog.dataset.root + '/';
  const add = dialog.querySelector('[data-upsell-add]');
  const gap = dialog.querySelector('[data-upsell-gap]');
  const error = dialog.querySelector('[data-upsell-error]');
  const originalLabel = add.textContent;
  let cart = null;
  let checking = false;
  let adding = false;
  let timer;
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
  const signature = (value) => value.total_price + ':' + value.items.map((item) => item.key + ':' + item.quantity).sort().join('|');
  const seen = new Set();
  const wasSeen = (key) => {
    try { return sessionStorage.getItem('mpc-upsell:' + key) === '1' || seen.has(key); }
    catch { return seen.has(key); }
  };
  const remember = (key) => {
    seen.add(key);
    try { sessionStorage.setItem('mpc-upsell:' + key, '1'); } catch {}
  };
  const check = async () => {
    if (checking || adding || dialog.open) return;
    checking = true;
    try {
      const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) return;
      cart = await response.json();
      if (cart.currency !== 'USD' || !cart.item_count || cart.total_price >= Number(dialog.dataset.threshold)) return;
      if (cart.items.some((item) => String(item.product_id) === dialog.dataset.product)) return;
      const key = signature(cart);
      if (wasSeen(key)) return;
      const foreignModal = document.querySelector('dialog:modal:not(#mpc-shipping-upsell)');
      if (foreignModal && !foreignModal.querySelector('cart-drawer-component')) return;
      gap.textContent = dialog.dataset.gapText.replace('[[amount]]', money(Number(dialog.dataset.threshold) - cart.total_price));
      error.textContent = '';
      remember(key);
      dialog.showModal();
    } catch {} finally { checking = false; }
  };
  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(check, 700);
  };
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    if (event.promise) event.promise.then(schedule).catch(() => {});
    else schedule();
  });
  document.addEventListener(DrawerOpenEvent.eventName, schedule);
  if (location.pathname.replace(/\/$/, '').endsWith('/cart')) schedule();
  dialog.querySelectorAll('[data-upsell-close]').forEach((button) => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  add.addEventListener('click', async () => {
    if (adding) return;
    adding = true;
    add.disabled = true;
    add.textContent = dialog.dataset.addingText;
    error.textContent = '';
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(dialog.dataset.variant), quantity: 1 }] })
      });
      if (!response.ok) throw new Error('add failed');
      location.assign(root + 'cart');
    } catch {
      error.textContent = dialog.dataset.errorText;
      add.disabled = false;
      add.textContent = originalLabel;
      adding = false;
    }
  });
}
